
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13238',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13238",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.792",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9959",
  "foundations-components": "static-1.8497",
  "foundations-components-legacy": "static-1.1522",
  "foundations-theming": "static-1.4779",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8335",
  "hub-http-shared-msw-handlers": "static-1.10620",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11793",
  "I18n": "static-7.1673",
  "jasmine-runner": "static-1.6755",
  "marketplace-discovery-studio-lib": "static-1.637",
  "marketplace-storefront-base": "static-1.13301",
  "quartz": "static-1.7459",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.17025",
  "reactive-variable-buffer-atom": "static-1.3160",
  "reporting-testing-lib": "static-1.10759",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12829",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7630",
  "ui-addon-i18n": "static-1.11451",
  "ui-addon-react-router-dom": "static-1.9839",
  "unified-auth": "static-1.924",
  "unified-auth-core-lib": "static-1.1206",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8405",
  "hub-http": "static-1.6517",
  "integrations-lib": "static-1.17035",
  "marketplace-ui-common": "static-1.20728",
  "marketplace-ui-install": "static-1.714",
  "property-management-iframe": "static-1.14140",
  "quartz-config": "static-1.1237",
  "quartz-core": "static-1.6678",
  "quartz-routing": "static-1.889",
  "quick-fetch": "static-1.4130",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4970",
  "ts-schema": "static-1.4294",
  "ui-universal-auth": "static-1.9410",
  "UIComponents": "static-3.8739",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3621",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3736",
  "quartz-webpack": "static-1.3683",
  "bend-plugin-quartz-routing": "static-1.537",
  "ai-components-ui-library": "static-1.9718",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5189",
  "pulse": "static-1.933",
  "react-codemirror": "static-1.10944",
  "ui-extensions-preview-lib": "static-1.611",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4766",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2495",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9728",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.70",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5557",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.502",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2645",
  "ui-fonts": "static-1.1055",
  "ui-images": "static-2.1249",
  "bend-plugin-foundations-theming": "static-1.3262",
  "foundations-theming-base": "static-1.3764",
  "stylex": "static-1.41",
  "HeadJS": "static-2.797",
  "hs-test-utils-bend-plugin": "static-1.3446",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4617",
  "ui-addon-video-player": "static-1.9007",
  "ai-rendering-library": "static-1.11101",
  "chirp-fetch": "static-1.2197",
  "connections-embed-lib": "static-1.1514",
  "copilot-toolkit": "static-1.11850",
  "feedback-loader": "static-1.29813",
  "laboratory-lib": "static-3.7456",
  "marketplace-embed": "static-1.22914",
  "marketplace-ui-details": "static-1.10623",
  "marketplace-ui-reviews": "static-1.20683",
  "marketplace-ui-tracking": "static-1.14898",
  "sanitize-text": "static-1.8458",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7200",
  "quartz-head": "static-1.1124",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4960",
  "immer": "static-1.101",
  "immerable": "static-1.4451",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2686",
  "reporting-data": "static-1.68826",
  "cssUtils": "static-1.925",
  "flux-actions": "static-1.368",
  "react-colorpicker": "static-2.10521",
  "react-dnd-compat": "static-1.4920",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10674",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.683",
  "marketplace-ui-apps-core": "static-1.19260",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4811",
  "foundations-components-test-utils": "static-1.5980",
  "quartz-i18n": "static-1.1134",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.459",
  "ads-unified-auth-lib": "static-1.1376",
  "generic-oauth-auth-lib": "static-1.52",
  "google-sheets-integration-lib": "static-1.1028",
  "microsoft-drive-auth-lib": "static-1.142",
  "surveymonkey-integration-lib": "static-1.485",
  "slack-ui-library": "static-1.10703",
  "fsm": "static-1.4053",
  "customer-data-objects": "static-1.7995",
  "property-translator": "static-1.5698",
  "hs-locale-management": "static-1.295",
  "frontend-preferences-client": "static-1.8226",
  "hs-promise-utils": "static-1.5899",
  "hubspot-apollo-client": "static-1.5181",
  "integrations-error-boundary-lib": "static-1.14450",
  "integrations-tracking-lib": "static-1.5911",
  "native-integrations-shared-strings": "static-1.8081",
  "sanitize": "static-1.4775",
  "superstore": "static-1.5062",
  "ui-shepherd-react": "static-3.10574",
  "ai-settings-ui-library": "static-1.8353",
  "hub-http-janus": "static-1.879",
  "hubspotter-http": "static-1.4864",
  "immutable-less": "static-1.4954",
  "marketplace-ui-client-types": "static-1.18135",
  "nav-meta": "static-1.30472",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18389",
  "ui-product-approvals-common": "static-1.1062",
  "ai-studio-lib": "static-1.12446",
  "hubspot-prosemirror": "static-1.18969",
  "integrations-reconnect-lib": "static-1.487",
  "ui-addon-iframeable": "static-1.9380",
  "ui-addon-integrations-directory-panel": "static-2.8330",
  "ui-product-approvals": "static-1.29167",
  "ui-tool-access": "static-1.10458",
  "inbound-db-properties-service-client": "static-1.4054",
  "property-management-common": "static-1.6428",
  "opentelemetry-fe-types": "static-1.74",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.576",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.449",
  "quartz-auth": "static-1.1134",
  "quartz-test": "static-1.1134",
  "quartz-tracking": "static-1.838",
  "trellis-components": "static-1.2664",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.380",
  "HubStyle": "static-2.12100",
  "bender-build-tools": "static-1.3444",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23032",
  "ContentUtils": "static-1.69126",
  "customer-data-objects-ui-components": "static-1.13334",
  "sassPrefix": "static-1.195",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.436",
  "batch-promise": "static-1.1848",
  "event-emitter": "static-1.1257",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5756",
  "magpie-types": "static-1.5216",
  "stylex-utils": "static-1.140",
  "trellis-theming": "static-1.1277",
  "avatar-components": "static-1.2785",
  "breeze-engine-core": "static-1.1015",
  "breeze-onboarding-components": "static-1.740",
  "customer-data-filters-ui": "static-1.40928",
  "customer-data-reference-ui-components": "static-1.13481",
  "embedded-academy-lib": "static-1.15518",
  "ExportDialog": "static-6.10681",
  "global-styles-ai-lib": "static-1.132",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.617",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42048",
  "reporting-snowflake": "static-1.57443",
  "reporting-ui-components": "static-2.66096",
  "reporting-visualizations": "static-1.60901",
  "trial-components-library": "static-1.14109",
  "ui-addon-teams": "static-1.21910",
  "upgrade-components-lib": "static-1.524",
  "navigation-components": "static-1.18835",
  "breeze-engine-lib": "static-1.1737",
  "simple-logging-lib": "static-1.3355",
  "fail-safe": "static-1.257",
  "app-governance-lib": "static-1.2389",
  "developer-experience-shared-components": "static-1.10843",
  "purchase-motions-components": "static-1.6367",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10260",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4005",
  "reference-resolvers": "static-1.8485",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4222",
  "hubspot-apollo-cache": "static-1.640",
  "universal-page-editor-lib": "static-1.3312",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3528",
  "atom": "static-1.5390",
  "merchandise-lib": "static-1.278",
  "salesImages": "static-1.566",
  "ui-addon-draggable": "static-3.5063",
  "content-assistance-lib": "static-1.8201",
  "content-media-capture": "static-1.5436",
  "customer-data-ui-utilities": "static-1.10132",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24499",
  "growth-payments-core": "static-1.26180",
  "knowledge-content-types": "static-1.8647",
  "PatternValidationJS": "static-1.3197",
  "payment-link-components": "static-1.24170",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20307",
  "ui-addon-emoji-picker": "static-1.10190",
  "ui-business-units-lib": "static-1.9392",
  "video-components-external": "static-1.12148",
  "video-data-lib": "static-1.35806",
  "navigation-messaging": "static-1.8162",
  "collaboration-sidebar": "static-1.58719",
  "crm-component-utils": "static-1.39836",
  "crm-properties-common-lib": "static-1.6191",
  "customer-data-properties": "static-1.52599",
  "external-options-client-types": "static-1.4339",
  "framework-data-schema-resolvers": "static-1.7196",
  "property-value-citations": "static-1.3213",
  "reference-resolvers-lite": "static-1.8407",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10618",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5117",
  "content-icons-ui": "static-1.2367",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1022",
  "breeze-artifacts-sdk": "static-1.340",
  "onboarding-journeys-lib": "static-1.917",
  "onboarding-scopes": "static-1.6756",
  "conversations-skeleton-state": "static-1.7550",
  "crm-message-bus": "static-1.43762",
  "customer-data-filters-ui-msw-helpers": "static-1.23363",
  "events-data-lib": "static-1.549",
  "FormUrlGenerator": "static-2.5030",
  "framework-builder-read-service-client": "static-1.4220",
  "hs-resources": "static-1.495",
  "multi-account-reference-resolvers": "static-1.1309",
  "onboarding-tours": "static-1.17121",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14465",
  "academy-common-lib": "static-1.14978",
  "dashboard-lib": "static-1.82827",
  "getting-started-shared-tasks": "static-1.19239",
  "hubspot-prosemirror-plugins": "static-1.18961",
  "share-with-third-party-component-lib": "static-1.9011",
  "ui-asset-management-lib": "static-1.11402",
  "user-context": "static-1.5424",
  "reporting-plugins": "static-1.10756",
  "reporting-reports": "static-1.68503",
  "hubs-service-types": "static-1.1563",
  "purchase-motions-api": "static-1.6370",
  "signup-constants": "static-1.19631",
  "nest": "static-1.540",
  "breeze-engine-chat-components": "static-1.715",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.208",
  "framework-listing-lib": "static-2.29494",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31434",
  "apps-service-types": "static-1.4042",
  "oauth-service-types": "static-1.4542",
  "signup-ui-url-generator": "static-2.8364",
  "onboarding-tours-client": "static-1.5336",
  "one-click-checkout": "static-1.412",
  "platform-infra-nav-components": "static-1.7893",
  "subscription-experience-data-types": "static-1.15246",
  "crm-record-cards-service-types": "static-1.3788",
  "location-customization-utils-lib": "static-1.10096",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29305",
  "content-media-composition-data-lib": "static-1.13240",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4730",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.728",
  "ui-addon-opt": "static-4.8667",
  "commerce-tours-lib": "static-1.6618",
  "growth-onboarding-reliability": "static-1.5385",
  "sales-checkout-service-client": "static-1.3832",
  "data-token-picker": "static-1.16891",
  "FileManagerLib": "static-1.40139",
  "content-media-compositions": "static-2.17247",
  "media-bridge-lib": "static-1.19408",
  "chatspot-widget-iframe": "static-1.23023",
  "collaboration-sidebar-common": "static-1.3516",
  "marketing-platform-lib": "static-1.7174",
  "card-properties-lib": "static-1.45008",
  "commerce-subscription-lib": "static-1.37780",
  "crm-actions": "static-1.6656",
  "crm-cards-sdk": "static-1.44574",
  "customer-data-properties-shared-msw-handlers": "static-1.9947",
  "customer-data-tracking": "static-1.7186",
  "calling-global-api": "static-1.65625",
  "calling-internal-common": "static-1.31625",
  "calling-lifecycle-internal": "static-1.67007",
  "calling-lifecycle-messages": "static-1.59301",
  "commerce-products-lib": "static-1.10528",
  "conditional-properties-service-client": "static-1.4015",
  "crm-index-visualization-core": "static-1.4544",
  "crm-links": "static-1.6633",
  "crm-pipelines-api-client-types": "static-1.4348",
  "formula-editor": "static-1.14770",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4427",
  "meetings-icalendar-utils-lib": "static-1.940",
  "multi-currency-client-types": "static-1.3910",
  "object-builder-ui-client": "static-1.49675",
  "pipeline-validation-client-types": "static-1.4182",
  "smart-data-capture-core": "static-1.143",
  "smart-property-lib": "static-1.8296",
  "tiered-pricing": "static-1.1957",
  "topics-actions-lib": "static-1.470",
  "ui-addon-form-validation": "static-1.11286",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.315",
  "framework-data-schema-quick-fetch": "static-1.7101",
  "restore-request-side-panel-lib": "static-1.1676",
  "growth-data-modal": "static-1.5899",
  "growth-onboarding-confetti": "static-1.3365",
  "growth-onboarding-next-action-utils": "static-1.2686",
  "onboarding-tours-utils": "static-1.1188",
  "ui-shepherd-tracker": "static-1.7955",
  "academy-service-client": "static-1.3991",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39998",
  "SafeStorage": "static-1.4708",
  "video-embed": "static-1.36640",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.25002",
  "viral-links-lib": "static-1.7379",
  "nested-table": "static-1.537",
  "timezone-utils": "static-2.5547",
  "getting-started-shared-tasks-store": "static-1.18357",
  "campaign-roi-lib": "static-1.10245",
  "campaigns-utils-lib": "static-1.3520",
  "ui-addon-calendars": "static-2.5637",
  "customer-data-views-management": "static-1.26028",
  "framework-data-table": "static-2.12553",
  "nudge-client-utils": "static-1.3150",
  "nudge-custom-ui-functions": "static-1.1495",
  "switchboard-lib": "static-1.520",
  "access-check-ui-lib": "static-1.1581",
  "app-users-service-client": "static-1.5921",
  "app-users-service-types": "static-1.5329",
  "mini-checkout-client": "static-1.27507",
  "onboarding-utils": "static-1.5672",
  "permissions-shared-i18n-strings-fe": "static-1.2120",
  "ui-coaching-tips-shared-config": "static-1.29290",
  "checkout-sdk": "static-3.24350",
  "payment-method-components": "static-1.7154",
  "touchless-buying-components": "static-1.6218",
  "upgrade-catalog-service-types": "static-1.3774",
  "edison-service-client-types": "static-1.697",
  "growth-onboarding-feedback-components": "static-1.6888",
  "audio-components": "static-1.6346",
  "FileManagerImages": "static-1.37650",
  "video-components": "static-1.14150",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92830",
  "customer-data-sidebar": "static-2.46737",
  "enrichment-lib": "static-1.370",
  "ui-addon-draggable-compat": "static-2.4568",
  "universal-record-utils-lib": "static-1.1950",
  "commerce-billing-lib": "static-1.20183",
  "commerce-shared-components-lib": "static-1.19223",
  "commerce-tools-ui-lib": "static-1.11045",
  "crm-fe-perf": "static-1.23205",
  "calling-error-reporting": "static-1.31632",
  "shared-worker-versioning": "static-1.11345",
  "calling-usage-tracker": "static-1.6840",
  "voice-sms-access-library": "static-1.2058",
  "commerce-permissions": "static-1.1080",
  "products-iframe-lib": "static-1.8593",
  "products-ui-components-shared-msw-handlers": "static-1.11002",
  "crm-index-associations-lib": "static-1.6744",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10703",
  "sales-views-client-types": "static-1.4560",
  "bark-lib": "static-1.16816",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.651",
  "policy-lib": "static-1.7105",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10766",
  "onboarding-data-sync-lib": "static-1.2515",
  "growth-onboarding-next-action-components": "static-1.2714",
  "user-context-client": "static-1.4809",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4837",
  "outpost": "static-1.4458",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22159",
  "sales-email-signature-service-client": "static-1.4148",
  "ts-utils-lib": "static-1.453",
  "crm-export-dialog": "static-1.6586",
  "crm-index-ui-shimmer": "static-1.2641",
  "crm-view-components": "static-1.1161",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7630",
  "tasks-actions-lib": "static-1.127",
  "nudge-custom-function-registry": "static-1.2907",
  "nudge-renderer-utils": "static-1.3226",
  "whisper-core-api": "static-1.7323",
  "InboxConnectUtils": "static-4.15558",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46841",
  "hub-http-rxjs": "static-1.843",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4292",
  "company-details-components": "static-1.6507",
  "react-performance-metrics-lib": "static-1.859",
  "pricing-pages-ui-components": "static-1.15805",
  "quote-checkout-service-types": "static-1.3758",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22498",
  "customer-data-email": "static-1.18528",
  "card-payment-highlight-lib": "static-1.37976",
  "commerce-contract-lib": "static-1.13325",
  "invoices-highlight-card-lib": "static-1.55755",
  "orders-highlight-card-lib": "static-1.22193",
  "products-highlight-card-lib": "static-1.18811",
  "quotes-highlight-card-lib": "static-1.72834",
  "crm-source-interpretation-lib": "static-1.5634",
  "data-agent-utils": "static-1.432",
  "crm-object-search-query-utilities": "static-1.10193",
  "utility-belt": "static-1.2836",
  "payments-enrollment-embed-lib": "static-1.23832",
  "stripe-embedded-components": "static-1.8000",
  "customer-data-rte": "static-1.33649",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6278",
  "payments-post-enroll-local-storage-lib": "static-1.5409",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38924",
  "calling-orchestration-schema": "static-1.36835",
  "react-reducer-toolkit": "static-1.16364",
  "meetings-connect-utils-lib": "static-1.7913",
  "hub-http-contrib": "static-1.3343",
  "ui-addon-sales-email": "static-1.5515",
  "access-control-lib": "static-1.10740",
  "EmailComponents": "static-1.55546",
  "EmailData": "static-1.54224",
  "redux-less": "static-2.9782",
  "company-details-service-types": "static-1.4243",
  "segments-query-core": "static-1.1727",
  "pricing-pages-api": "static-1.15670",
  "sequences-lib": "static-1.8533",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41046",
  "accounting-integrations-ui-components": "static-1.7539",
  "invoices-ui-lib": "static-1.55771",
  "commerce-products-api": "static-1.2693",
  "invoices-iframe-lib": "static-1.57829",
  "quotes-modal-lib": "static-1.103512",
  "quotes-ui-lib": "static-1.81555",
  "stripe-connect-js": "static-1.76",
  "draft-content-plugins": "static-1.28905",
  "ContentComponents": "static-2.72082",
  "ContentData": "static-1.69201",
  "marketing-contacts-lib": "static-1.11027",
  "marketing-email-service-types": "static-1.2095",
  "messaging-editing-lib": "static-1.47145",
  "messaging-usage-based-billing-components-lib": "static-1.2007",
  "automation-ui-source-apps": "static-1.19687",
  "automation-ui-types": "static-1.20605",
  "messaging-types-lib": "static-1.46882",
  "onboarding-settings-client": "static-1.4811",
  "sequences-client-types-lib": "static-1.8390",
  "commerce-tax-lib": "static-1.843",
  "price-books-api": "static-1.1733",
  "price-books-components": "static-1.1791",
  "property-description-translator": "static-1.4141",
  "ramp-editor": "static-1.891",
  "commerce-analytics-service-client": "static-1.3820",
  "totals-ui-components": "static-1.24294",
  "SalesContentIndexUI": "static-3.9626",
  "advanced-menus-core": "static-1.15578",
  "advanced-menus-lib": "static-1.12452",
  "automation-ui-ubb": "static-1.6521",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7641",
  "data-token-views": "static-1.16872",
  "forms-utils-lib": "static-1.13095",
  "payments-embed-points-lib": "static-1.13592",
  "react-tinymce": "static-1.55981",
  "simple-menus-core": "static-1.15577",
  "simple-menus-lib": "static-1.17094",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55107",
  "tinymce-data": "static-1.41192",
  "tinymce-plugins": "static-1.58221",
  "tinymce-themes": "static-1.57077",
  "ui-brand-identity-lib": "static-1.16475",
  "ui-memberships-settings-lib": "static-1.34842",
  "videoconference-integration-components": "static-1.7283",
  "marketing-contacts-client": "static-1.7813",
  "mc-hard-limits-client-types": "static-1.209",
  "automation-applications-service-types": "static-1.3652",
  "automation-platform-service-types": "static-1.2663",
  "ContentEditorUI": "static-2.77906",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4219",
  "web-interactives-components": "static-1.14250",
  "web-interactives-data": "static-1.14251",
  "messaging-shared-utils-lib": "static-1.1456",
  "messaging-user-info-utils-lib": "static-1.1626",
  "email-portal-health-service-types": "static-1.1282",
  "line-items-api": "static-1.1097",
  "commerce-totals-service-types": "static-1.4032",
  "FireAlarmUi": "static-1.4722",
  "sales-templates-service-types-lib": "static-1.4384",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22541",
  "automation-ui-usage-tracking": "static-1.22004",
  "data-studio-ubb": "static-1.3509",
  "interframe": "static-3.5059",
  "layout-dnd-components": "static-1.12970",
  "layout-dnd-utils": "static-1.11945",
  "NamespacedHubStyle": "static-2.9265",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27660",
  "content-management-data-lib": "static-1.5958",
  "copilot-plugins": "static-1.11822",
  "cta-picker": "static-1.37084",
  "customer-agent-discovery-components-lib": "static-1.3953",
  "editor-components": "static-1.13649",
  "editor-iframe-lib": "static-1.8799",
  "error-messaging-js": "static-1.5499",
  "FormsCommonComponents": "static-1.86558",
  "layout-data-lib": "static-1.10270",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10953",
  "SharedLegalStrings": "static-1.2049",
  "smart-content-core": "static-1.43174",
  "smart-content-lib": "static-1.43827",
  "social-composer-lib": "static-1.60301",
  "structured-content-lib": "static-1.25917",
  "theme-previewer-lib": "static-1.53947",
  "tinymce-copilot": "static-1.17175",
  "xray-recommendation-lib": "static-1.8263",
  "automation-ui-routing": "static-1.21962",
  "sql-reporting-client-types": "static-1.5898",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42792",
  "reporting-enablement": "static-1.23834",
  "forms-ai-lib": "static-1.4765",
  "codemirror-dlb": "static-1.59465",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6742",
  "report-customization-components": "static-1.13915",
  "data-quality-ui-library": "static-1.13802",
  "reporting-filters": "static-1.1006",
  "reporting-insights-lib": "static-1.2570",
  "merge-modal-lib": "static-1.12558",
  "segments-client-types": "static-1.11529"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13238",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.792",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9959",
  "foundations-components": "/foundations-components/static-1.8497",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1522",
  "foundations-theming": "/foundations-theming/static-1.4779",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8335",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10620",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11793",
  "I18n": "/I18n/static-7.1673",
  "jasmine-runner": "/jasmine-runner/static-1.6755",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.637",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13301",
  "quartz": "/quartz/static-1.7459",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.17025",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3160",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10759",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12829",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7630",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11451",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9839",
  "unified-auth": "/unified-auth/static-1.924",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1206",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8405",
  "hub-http": "/hub-http/static-1.6517",
  "integrations-lib": "/integrations-lib/static-1.17035",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20728",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.714",
  "property-management-iframe": "/property-management-iframe/static-1.14140",
  "quartz-config": "/quartz-config/static-1.1237",
  "quartz-core": "/quartz-core/static-1.6678",
  "quartz-routing": "/quartz-routing/static-1.889",
  "quick-fetch": "/quick-fetch/static-1.4130",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4970",
  "ts-schema": "/ts-schema/static-1.4294",
  "ui-universal-auth": "/ui-universal-auth/static-1.9410",
  "UIComponents": "/UIComponents/static-3.8739",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3621",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3736",
  "quartz-webpack": "/quartz-webpack/static-1.3683",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.537",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9718",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5189",
  "pulse": "/pulse/static-1.933",
  "react-codemirror": "/react-codemirror/static-1.10944",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.611",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4766",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2495",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9728",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.70",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5557",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2645",
  "ui-fonts": "/ui-fonts/static-1.1055",
  "ui-images": "/ui-images/static-2.1249",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3262",
  "foundations-theming-base": "/foundations-theming-base/static-1.3764",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.797",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3446",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4617",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9007",
  "ai-rendering-library": "/ai-rendering-library/static-1.11101",
  "chirp-fetch": "/chirp-fetch/static-1.2197",
  "connections-embed-lib": "/connections-embed-lib/static-1.1514",
  "copilot-toolkit": "/copilot-toolkit/static-1.11850",
  "feedback-loader": "/feedback-loader/static-1.29813",
  "laboratory-lib": "/laboratory-lib/static-3.7456",
  "marketplace-embed": "/marketplace-embed/static-1.22914",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10623",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20683",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14898",
  "sanitize-text": "/sanitize-text/static-1.8458",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7200",
  "quartz-head": "/quartz-head/static-1.1124",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4960",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4451",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2686",
  "reporting-data": "/reporting-data/static-1.68826",
  "cssUtils": "/cssUtils/static-1.925",
  "flux-actions": "/flux-actions/static-1.368",
  "react-colorpicker": "/react-colorpicker/static-2.10521",
  "react-dnd-compat": "/react-dnd-compat/static-1.4920",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10674",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.683",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19260",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4811",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5980",
  "quartz-i18n": "/quartz-i18n/static-1.1134",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.459",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1376",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.52",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1028",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.142",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.485",
  "slack-ui-library": "/slack-ui-library/static-1.10703",
  "fsm": "/fsm/static-1.4053",
  "customer-data-objects": "/customer-data-objects/static-1.7995",
  "property-translator": "/property-translator/static-1.5698",
  "hs-locale-management": "/hs-locale-management/static-1.295",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8226",
  "hs-promise-utils": "/hs-promise-utils/static-1.5899",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5181",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14450",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5911",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8081",
  "sanitize": "/sanitize/static-1.4775",
  "superstore": "/superstore/static-1.5062",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10574",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8353",
  "hub-http-janus": "/hub-http-janus/static-1.879",
  "hubspotter-http": "/hubspotter-http/static-1.4864",
  "immutable-less": "/immutable-less/static-1.4954",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18135",
  "nav-meta": "/nav-meta/static-1.30472",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18389",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1062",
  "ai-studio-lib": "/ai-studio-lib/static-1.12446",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18969",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.487",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9380",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8330",
  "ui-product-approvals": "/ui-product-approvals/static-1.29167",
  "ui-tool-access": "/ui-tool-access/static-1.10458",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4054",
  "property-management-common": "/property-management-common/static-1.6428",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.74",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.576",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.449",
  "quartz-auth": "/quartz-auth/static-1.1134",
  "quartz-test": "/quartz-test/static-1.1134",
  "quartz-tracking": "/quartz-tracking/static-1.838",
  "trellis-components": "/trellis-components/static-1.2664",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.380",
  "HubStyle": "/HubStyle/static-2.12100",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23032",
  "ContentUtils": "/ContentUtils/static-1.69126",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13334",
  "sassPrefix": "/sassPrefix/static-1.195",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.436",
  "batch-promise": "/batch-promise/static-1.1848",
  "event-emitter": "/event-emitter/static-1.1257",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5756",
  "magpie-types": "/magpie-types/static-1.5216",
  "stylex-utils": "/stylex-utils/static-1.140",
  "trellis-theming": "/trellis-theming/static-1.1277",
  "avatar-components": "/avatar-components/static-1.2785",
  "breeze-engine-core": "/breeze-engine-core/static-1.1015",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.740",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40928",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13481",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15518",
  "ExportDialog": "/ExportDialog/static-6.10681",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.132",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.617",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42048",
  "reporting-snowflake": "/reporting-snowflake/static-1.57443",
  "reporting-ui-components": "/reporting-ui-components/static-2.66096",
  "reporting-visualizations": "/reporting-visualizations/static-1.60901",
  "trial-components-library": "/trial-components-library/static-1.14109",
  "ui-addon-teams": "/ui-addon-teams/static-1.21910",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.524",
  "navigation-components": "/navigation-components/static-1.18835",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1737",
  "simple-logging-lib": "/simple-logging-lib/static-1.3355",
  "fail-safe": "/fail-safe/static-1.257",
  "app-governance-lib": "/app-governance-lib/static-1.2389",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10843",
  "purchase-motions-components": "/purchase-motions-components/static-1.6367",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10260",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4005",
  "reference-resolvers": "/reference-resolvers/static-1.8485",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4222",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.640",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3312",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3528",
  "atom": "/atom/static-1.5390",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "salesImages": "/salesImages/static-1.566",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5063",
  "content-assistance-lib": "/content-assistance-lib/static-1.8201",
  "content-media-capture": "/content-media-capture/static-1.5436",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10132",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24499",
  "growth-payments-core": "/growth-payments-core/static-1.26180",
  "knowledge-content-types": "/knowledge-content-types/static-1.8647",
  "PatternValidationJS": "/PatternValidationJS/static-1.3197",
  "payment-link-components": "/payment-link-components/static-1.24170",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20307",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10190",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9392",
  "video-components-external": "/video-components-external/static-1.12148",
  "video-data-lib": "/video-data-lib/static-1.35806",
  "navigation-messaging": "/navigation-messaging/static-1.8162",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58719",
  "crm-component-utils": "/crm-component-utils/static-1.39836",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6191",
  "customer-data-properties": "/customer-data-properties/static-1.52599",
  "external-options-client-types": "/external-options-client-types/static-1.4339",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7196",
  "property-value-citations": "/property-value-citations/static-1.3213",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8407",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10618",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5117",
  "content-icons-ui": "/content-icons-ui/static-1.2367",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1022",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.340",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.917",
  "onboarding-scopes": "/onboarding-scopes/static-1.6756",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7550",
  "crm-message-bus": "/crm-message-bus/static-1.43762",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23363",
  "events-data-lib": "/events-data-lib/static-1.549",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5030",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4220",
  "hs-resources": "/hs-resources/static-1.495",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1309",
  "onboarding-tours": "/onboarding-tours/static-1.17121",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14465",
  "academy-common-lib": "/academy-common-lib/static-1.14978",
  "dashboard-lib": "/dashboard-lib/static-1.82827",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19239",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18961",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9011",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11402",
  "user-context": "/user-context/static-1.5424",
  "reporting-plugins": "/reporting-plugins/static-1.10756",
  "reporting-reports": "/reporting-reports/static-1.68503",
  "hubs-service-types": "/hubs-service-types/static-1.1563",
  "purchase-motions-api": "/purchase-motions-api/static-1.6370",
  "signup-constants": "/signup-constants/static-1.19631",
  "nest": "/nest/static-1.540",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.715",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.208",
  "framework-listing-lib": "/framework-listing-lib/static-2.29494",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31434",
  "apps-service-types": "/apps-service-types/static-1.4042",
  "oauth-service-types": "/oauth-service-types/static-1.4542",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8364",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5336",
  "one-click-checkout": "/one-click-checkout/static-1.412",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7893",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15246",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3788",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10096",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29305",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13240",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4730",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.728",
  "ui-addon-opt": "/ui-addon-opt/static-4.8667",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6618",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5385",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3832",
  "data-token-picker": "/data-token-picker/static-1.16891",
  "FileManagerLib": "/FileManagerLib/static-1.40139",
  "content-media-compositions": "/content-media-compositions/static-2.17247",
  "media-bridge-lib": "/media-bridge-lib/static-1.19408",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23023",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3516",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7174",
  "card-properties-lib": "/card-properties-lib/static-1.45008",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37780",
  "crm-actions": "/crm-actions/static-1.6656",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44574",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9947",
  "customer-data-tracking": "/customer-data-tracking/static-1.7186",
  "calling-global-api": "/calling-global-api/static-1.65625",
  "calling-internal-common": "/calling-internal-common/static-1.31625",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67007",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59301",
  "commerce-products-lib": "/commerce-products-lib/static-1.10528",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4015",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4544",
  "crm-links": "/crm-links/static-1.6633",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4348",
  "formula-editor": "/formula-editor/static-1.14770",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4427",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.940",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3910",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49675",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4182",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.143",
  "smart-property-lib": "/smart-property-lib/static-1.8296",
  "tiered-pricing": "/tiered-pricing/static-1.1957",
  "topics-actions-lib": "/topics-actions-lib/static-1.470",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11286",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.315",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7101",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1676",
  "growth-data-modal": "/growth-data-modal/static-1.5899",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3365",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2686",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1188",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7955",
  "academy-service-client": "/academy-service-client/static-1.3991",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39998",
  "SafeStorage": "/SafeStorage/static-1.4708",
  "video-embed": "/video-embed/static-1.36640",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25002",
  "viral-links-lib": "/viral-links-lib/static-1.7379",
  "nested-table": "/nested-table/static-1.537",
  "timezone-utils": "/timezone-utils/static-2.5547",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18357",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10245",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3520",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5637",
  "customer-data-views-management": "/customer-data-views-management/static-1.26028",
  "framework-data-table": "/framework-data-table/static-2.12553",
  "nudge-client-utils": "/nudge-client-utils/static-1.3150",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1495",
  "switchboard-lib": "/switchboard-lib/static-1.520",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1581",
  "app-users-service-client": "/app-users-service-client/static-1.5921",
  "app-users-service-types": "/app-users-service-types/static-1.5329",
  "mini-checkout-client": "/mini-checkout-client/static-1.27507",
  "onboarding-utils": "/onboarding-utils/static-1.5672",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2120",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29290",
  "checkout-sdk": "/checkout-sdk/static-3.24350",
  "payment-method-components": "/payment-method-components/static-1.7154",
  "touchless-buying-components": "/touchless-buying-components/static-1.6218",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3774",
  "edison-service-client-types": "/edison-service-client-types/static-1.697",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6888",
  "audio-components": "/audio-components/static-1.6346",
  "FileManagerImages": "/FileManagerImages/static-1.37650",
  "video-components": "/video-components/static-1.14150",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92830",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46737",
  "enrichment-lib": "/enrichment-lib/static-1.370",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4568",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1950",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20183",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19223",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11045",
  "crm-fe-perf": "/crm-fe-perf/static-1.23205",
  "calling-error-reporting": "/calling-error-reporting/static-1.31632",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11345",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6840",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2058",
  "commerce-permissions": "/commerce-permissions/static-1.1080",
  "products-iframe-lib": "/products-iframe-lib/static-1.8593",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11002",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6744",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10703",
  "sales-views-client-types": "/sales-views-client-types/static-1.4560",
  "bark-lib": "/bark-lib/static-1.16816",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.651",
  "policy-lib": "/policy-lib/static-1.7105",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10766",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2515",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2714",
  "user-context-client": "/user-context-client/static-1.4809",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4837",
  "outpost": "/outpost/static-1.4458",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22159",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4148",
  "ts-utils-lib": "/ts-utils-lib/static-1.453",
  "crm-export-dialog": "/crm-export-dialog/static-1.6586",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2641",
  "crm-view-components": "/crm-view-components/static-1.1161",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7630",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.127",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2907",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3226",
  "whisper-core-api": "/whisper-core-api/static-1.7323",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15558",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46841",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.843",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4292",
  "company-details-components": "/company-details-components/static-1.6507",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.859",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15805",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3758",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22498",
  "customer-data-email": "/customer-data-email/static-1.18528",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37976",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13325",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55755",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22193",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18811",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72834",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5634",
  "data-agent-utils": "/data-agent-utils/static-1.432",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10193",
  "utility-belt": "/utility-belt/static-1.2836",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23832",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8000",
  "customer-data-rte": "/customer-data-rte/static-1.33649",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6278",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5409",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38924",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36835",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16364",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7913",
  "hub-http-contrib": "/hub-http-contrib/static-1.3343",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5515",
  "access-control-lib": "/access-control-lib/static-1.10740",
  "EmailComponents": "/EmailComponents/static-1.55546",
  "EmailData": "/EmailData/static-1.54224",
  "redux-less": "/redux-less/static-2.9782",
  "company-details-service-types": "/company-details-service-types/static-1.4243",
  "segments-query-core": "/segments-query-core/static-1.1727",
  "pricing-pages-api": "/pricing-pages-api/static-1.15670",
  "sequences-lib": "/sequences-lib/static-1.8533",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41046",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7539",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55771",
  "commerce-products-api": "/commerce-products-api/static-1.2693",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57829",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103512",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81555",
  "stripe-connect-js": "/stripe-connect-js/static-1.76",
  "draft-content-plugins": "/draft-content-plugins/static-1.28905",
  "ContentComponents": "/ContentComponents/static-2.72082",
  "ContentData": "/ContentData/static-1.69201",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.11027",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2095",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47145",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2007",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19687",
  "automation-ui-types": "/automation-ui-types/static-1.20605",
  "messaging-types-lib": "/messaging-types-lib/static-1.46882",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4811",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8390",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.843",
  "price-books-api": "/price-books-api/static-1.1733",
  "price-books-components": "/price-books-components/static-1.1791",
  "property-description-translator": "/property-description-translator/static-1.4141",
  "ramp-editor": "/ramp-editor/static-1.891",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3820",
  "totals-ui-components": "/totals-ui-components/static-1.24294",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9626",
  "advanced-menus-core": "/advanced-menus-core/static-1.15578",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12452",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6521",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7641",
  "data-token-views": "/data-token-views/static-1.16872",
  "forms-utils-lib": "/forms-utils-lib/static-1.13095",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13592",
  "react-tinymce": "/react-tinymce/static-1.55981",
  "simple-menus-core": "/simple-menus-core/static-1.15577",
  "simple-menus-lib": "/simple-menus-lib/static-1.17094",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55107",
  "tinymce-data": "/tinymce-data/static-1.41192",
  "tinymce-plugins": "/tinymce-plugins/static-1.58221",
  "tinymce-themes": "/tinymce-themes/static-1.57077",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16475",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34842",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7283",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7813",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.209",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3652",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
  "ContentEditorUI": "/ContentEditorUI/static-2.77906",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4219",
  "web-interactives-components": "/web-interactives-components/static-1.14250",
  "web-interactives-data": "/web-interactives-data/static-1.14251",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1456",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1626",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1282",
  "line-items-api": "/line-items-api/static-1.1097",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4032",
  "FireAlarmUi": "/FireAlarmUi/static-1.4722",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4384",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22541",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22004",
  "data-studio-ubb": "/data-studio-ubb/static-1.3509",
  "interframe": "/interframe/static-3.5059",
  "layout-dnd-components": "/layout-dnd-components/static-1.12970",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11945",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9265",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27660",
  "content-management-data-lib": "/content-management-data-lib/static-1.5958",
  "copilot-plugins": "/copilot-plugins/static-1.11822",
  "cta-picker": "/cta-picker/static-1.37084",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3953",
  "editor-components": "/editor-components/static-1.13649",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8799",
  "error-messaging-js": "/error-messaging-js/static-1.5499",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86558",
  "layout-data-lib": "/layout-data-lib/static-1.10270",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10953",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2049",
  "smart-content-core": "/smart-content-core/static-1.43174",
  "smart-content-lib": "/smart-content-lib/static-1.43827",
  "social-composer-lib": "/social-composer-lib/static-1.60301",
  "structured-content-lib": "/structured-content-lib/static-1.25917",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53947",
  "tinymce-copilot": "/tinymce-copilot/static-1.17175",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8263",
  "automation-ui-routing": "/automation-ui-routing/static-1.21962",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5898",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42792",
  "reporting-enablement": "/reporting-enablement/static-1.23834",
  "forms-ai-lib": "/forms-ai-lib/static-1.4765",
  "codemirror-dlb": "/codemirror-dlb/static-1.59465",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6742",
  "report-customization-components": "/report-customization-components/static-1.13915",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13802",
  "reporting-filters": "/reporting-filters/static-1.1006",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2570",
  "merge-modal-lib": "/merge-modal-lib/static-1.12558",
  "segments-client-types": "/segments-client-types/static-1.11529"
}
};
